import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import facepaint from './facepaint';
var mq = facepaint([640, 1152].map(function (bp) {
  return "@media (min-width: ".concat(bp, "px)");
}));
var defaultGutterWidths = [16];
var defaultContainerWidths = ['100%', 640, 1152];

var getWidthPercentageFromSizes = function getWidthPercentageFromSizes(sizes) {
  return sizes.map(function (size) {
    return "".concat(100 * size, "%");
  });
}; // Not currently used
// const getMsFlexPreferredSizes = (sizes: number[], paddings: string[]) =>
//   sizes.map((size, ind) => {
//     const padding = paddings[Math.min(ind, paddings.length - 1)]
//     return `calc(${100 * size}% - ${padding} * 2)`
//   })


export var container = function container() {
  var outerMargin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['0 auto'];
  var containerWidths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultContainerWidths;
  var gutterWidths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGutterWidths;
  var paddings = gutterWidths.map(function (gw) {
    return "".concat(gw, "px");
  });
  return mq({
    boxSizing: 'border-box',
    position: 'relative',
    margin: outerMargin,
    maxWidth: containerWidths,
    width: ['auto'].concat(_toConsumableArray(containerWidths.slice(1))),
    paddingLeft: paddings,
    paddingRight: paddings
  });
};
export var row = function row() {
  var centerX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var topSpacing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var bottomSpacing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var gutterWidths = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultGutterWidths;
  var margins = gutterWidths.map(function (gw) {
    return "-".concat(gw / 2, "px");
  });
  return mq({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    marginLeft: margins,
    marginRight: margins,
    marginTop: topSpacing,
    marginBottom: bottomSpacing,
    justifyContent: centerX ? 'center' : 'flex-start',
    flexWrap: 'wrap'
  });
};
export var column = function column() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hasPaddingTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hasPaddingBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var gutterWidths = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultGutterWidths;
  var paddings = gutterWidths.map(function (gw) {
    return "".concat(gw / 2, "px");
  });
  return mq({
    boxSizing: 'border-box',
    display: display,
    paddingLeft: paddings,
    paddingRight: paddings,
    paddingTop: hasPaddingTop ? paddings : [],
    paddingBottom: hasPaddingBottom ? paddings : [],
    width: getWidthPercentageFromSizes(sizes)
  });
};